export const formatCurrencyNumber = (num: number) =>
  Number(num.toFixed(2)).toLocaleString('currency', { maximumFractionDigits: 2 });
